import _ from 'lodash';

export const paramsWithFile = (params, files) => {
  const formData = _(params)
    .omit(files)
    .reduce((result, value, key) => {
      if (_.isArray(value)) {
        if (value.length > 0) {
          value.forEach(v => result.append(`${key}[]`, v));
        } else {
          result.append(key, null);
        }
      } else {
        result.append(key, value);
      }

      return result;
    }, new window.FormData());

  files.forEach(file => {
    if (typeof params[file] !== 'undefined' && _.isEmpty(params[file])) {
      formData.append(`remove_${file}`, true);
    } else if (_.isArray(params[file])) {
      params[file].forEach(fileInstance => formData.append(`${file}[]`, fileInstance));
    } else if (params[file] && !params[file].url) {
      formData.append(file, params[file]);
    }
  });

  return formData;
};

// Change to postalCode since we don't split parts of postal code
const isPostalCodeChanged = (target, value) =>{
  // Change to /.*postalCode/ since we since we don't split parts of postal code and change value.length === 5 to check length of postal code in thai form
  if(target.name && target.form && (target.name.match(/.*postalCode/) && value.length === 5)){
    return true;
  }
  return undefined;
}

// Change to postalCode since we don't split parts of postal code
const extractPostalCodeValue = target => {
  const prefix = target.name.match(/(.*postalCode)/).input;
  const postalCode = target.form.elements[`${prefix}`].value;
  return `${postalCode}`;
};

export const handlePostalCodeChange = event => (inputText, callback) => {
  const target = event.target;
  if (target.name.match(/(.*postalCode)/) && isPostalCodeChanged(target, inputText)) {
    const postcode = extractPostalCodeValue(target);
    if (postcode.match(/^(?!0)\d{5}/)) {
      return callback(postcode);
    }
  }

  return undefined;
};

export const detectButton = (func, buttonValue) => data => func({ ...data, afterSubmit: buttonValue });
export const isHonnin = value => value === '本人';
export const defaultCommutingItem = (type = 'train') => {
  switch (type) {
    case 'train':
      return {
        meansOfCommunication: type,
        oneWayFare: 0,
        paymentAmount: 0
      };

    case 'car':
      return {
        meansOfCommunication: type,
        commutingDistance: 'lessthan_2km',
        paymentAmount: 0
      };

    case 'bus':
      return {
        meansOfCommunication: type,
        oneWayFare: 0,
        paymentAmount: 0
      };

    default:
      return { meansOfCommunication: type };
  }
};

export const get24HoursOptions = () => _.range(24).map(hour => ({ value: `${hour}`, label: `${hour}:00` }));

export const takeFormErrors = (formErrors, fieldMap) => {
  const messages = [];

  if (formErrors === undefined) {
    return messages;
  }

  const keyPairs = _.toPairs(formErrors).filter(pair => Object.prototype.hasOwnProperty.call(fieldMap, pair[0]));
  return keyPairs.map(([key, value]) => `${fieldMap[key]}${value}`);
};

export const imageType = (image) => {
  if(image && image.url != null){
      return image.url
  }
  else if(typeof image === "string"){
      return image
  }
  else return null
}
